import type { TrendItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType } from './trendItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType';

export type TrendItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwo = {
  content?: string;
  /** 트윗 유형 */
  tweetType?: TrendItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType;
};
